import React from 'react';

const Loading: React.FC = () => {
    return <div className="loading"></div>
}
export default Loading;